// extracted by mini-css-extract-plugin
export default {"container":"ScannerLanding_container__8RkWU","grid":"ScannerLanding_grid__y6F49","option":"ScannerLanding_option__42ru9","card":"ScannerLanding_card__HrxnT"};